import { LICENSE_STATUS_LABELS } from '@shripos/shared/constants';
import { Badge } from './Display.jsx';

export function licenseTone(status) {
  return (
    { active: 'success', expiring: 'warning', grace: 'danger', expired: 'danger', suspended: 'neutral' }[status] ??
    'neutral'
  );
}

export function LicenseBadge({ status }) {
  return <Badge tone={licenseTone(status)}>{LICENSE_STATUS_LABELS[status] ?? status}</Badge>;
}
